
import axios from 'axios';
import { AxiosCreateResponse, CreateResponse, GetResponse } from "@ontime/types";
import AuthHeader from './AuthHeader';
import ApiURL from './ApiURL';
import { handleError } from './HandleError';
import { GetUsersByNameOrUserNameDto, UpdatePasswordByUserDto, UpdateUserDto, UserDto } from "@ontime/types";

const API_URL = ApiURL() + 'services/app/user';

class UserService {

    async GetUsersByNameOrUserName(Keyword: string) {
        return axios.get<GetResponse<GetUsersByNameOrUserNameDto[]>>(API_URL + "/GetUsersByNameOrUserName", {
            params: { Keyword },
            headers: AuthHeader()
        });
    }

    async UpdateByUser(input: UpdateUserDto): Promise<CreateResponse<UserDto>> {
        return axios.put<AxiosCreateResponse<UserDto>>(API_URL + '/UpdateByUser', input, {
            headers: AuthHeader()
        })
            .then(response => {
                return {
                    success: true,
                    response: response.data
                };
            })
            .catch((error) => handleError(error, 'Update error, please check your internet connection.'));

    }

    async UpdatePasswordByUser(input: UpdatePasswordByUserDto): Promise<CreateResponse<boolean>> {
        return axios.put<AxiosCreateResponse<boolean>>(API_URL + '/UpdatePasswordByUser', input, {
            headers: AuthHeader()
        })
            .then(response => {
                return {
                    success: true,
                    response: response.data
                };
            })
            .catch((error) => handleError(error, 'Update error, please check your internet connection.'));

    }

    Get(id: number) {
        return axios.get<GetResponse<UserDto>>(API_URL + "/Get", {
            params: { id },
            headers: AuthHeader(),
        });
    }

}

export default new UserService();